import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const LINKS = [
    { href: "#problem", label: "Problem" },
    { href: "#funktionsweise", label: "Funktionsweise" },
    { href: "#kalkulator", label: "Kalkulator" },
    { href: "#nutzen", label: "Nutzen" },
    { href: "#faq", label: "FAQ" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="fixed top-0 inset-x-0 z-50 border-b border-white/[0.08] bg-[#0B0F17]/80 backdrop-blur-xl">
            <nav
                className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between"
                aria-label="Hauptnavigation"
            >
                <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
                    <span className="status-dot h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true" />
                    <span className="font-heading font-semibold text-lg tracking-tight">Kirenzo</span>
                </a>
                <div className="hidden md:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="text-sm text-[#9CA3AF] hover:text-white transition-colors duration-200"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#demo"
                        data-testid="nav-cta-button"
                        className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500 px-4 py-2 text-sm font-semibold text-[#0B0F17] transition-colors duration-200 hover:bg-emerald-600"
                    >
                        Kostenlose Demo anfragen
                        <ArrowRight className="h-4 w-4" aria-hidden="true" />
                    </a>
                </div>
                <button
                    type="button"
                    data-testid="nav-mobile-toggle"
                    className="md:hidden p-2 text-[#9CA3AF] hover:text-white"
                    onClick={() => setOpen(!open)}
                    aria-expanded={open}
                    aria-label={open ? "Menü schließen" : "Menü öffnen"}
                >
                    {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
            </nav>
            {open && (
                <div className="md:hidden border-t border-white/[0.08] bg-[#0B0F17]/95 backdrop-blur-xl px-4 py-4 flex flex-col gap-4">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                            className="text-sm text-[#9CA3AF] hover:text-white"
                            onClick={() => setOpen(false)}
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#demo"
                        data-testid="nav-mobile-cta-button"
                        className="inline-flex items-center justify-center gap-1.5 rounded-full bg-emerald-500 px-4 py-2.5 text-sm font-semibold text-[#0B0F17]"
                        onClick={() => setOpen(false)}
                    >
                        Kostenlose Demo anfragen
                        <ArrowRight className="h-4 w-4" aria-hidden="true" />
                    </a>
                </div>
            )}
        </header>
    );
};
